import { createAction } from '@ngrx/store';
import { ProductMaintenance, ProductMaintenancePagination } from '@/app/_core/domain/models/control-panel/product-maintenance.model';

export const enum ProductMaintenanceActionsTypes {
  SetProductMaintenance = '[ProductMaintenance] Set ProductMaintenance',
  SetResponseProductMaintenance = '[ProductMaintenance] Set ResponseProductMaintenance'
}

export const setProductMaintenance = createAction(ProductMaintenanceActionsTypes.SetProductMaintenance, ({ productMaintenance }: { productMaintenance: ProductMaintenance }) => ({
  payload: { productMaintenance }
}));
export const setResponseProductMaintenance = createAction(
  ProductMaintenanceActionsTypes.SetResponseProductMaintenance,
  ({ responseProductMaintenance }: { responseProductMaintenance: ProductMaintenancePagination }) => ({
    payload: { responseProductMaintenance }
  })
);
